// FILE: src/components/app/SearchBaseComponent/SearchInput.jsx
import React, { useState } from "react";
import styles from "./SearchInput.module.css";

export default function SearchInput({ onSubmit, placeholder = "Search…" }) {
  const [value, setValue] = useState("");

  const submit = () => onSubmit?.(value);
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className={styles.bar}>
      <input
        type="text"
        className={styles.input}
        placeholder={placeholder}
        spellCheck={false}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
      />
      <div className={styles.actions}>
        {value && (
          <button
            type="button"
            className={`btn btn-link btn-sm ${styles.clear}`}
            onClick={() => setValue("")}
          >
            Clear
          </button>
        )}
        <button type="button" className="btn btn-primary btn-sm" onClick={submit}>
          Search
        </button>
      </div>
    </div>
  );
}